import Cookie from "js-cookie";
import { ERouteHttpVerb } from "@devowl-wp/api";
import { obfuscatePath } from "./obfuscatePath.js";
import { trailingslashit, untrailingslashit } from "../../helpers.js";
import { simpleHash } from "../../utils/simpleHash.js";
function applyQueryString(url, query, merge) {
    const params = merge ? url.searchParams : new URLSearchParams();
    const arr = Array.isArray(query) ? query : [
        query
    ];
    for (const q of arr){
        for (const [key, value] of Object.entries(q || {})){
            params.delete(key);
            if (Array.isArray(value)) {
                value.forEach((v)=>{
                    if (v !== null && v !== undefined) {
                        params.append(`${key}[]`, String(v));
                    }
                });
            } else if (value !== null && value !== undefined) {
                params.set(key, String(value));
            }
        }
    }
    url.search = params.toString();
    return url;
}
/**
 * Build an URL for a specific scheme.
 *
 * @param param0
 */ function commonUrlBuilder({ location, params = {}, nonce = true, options, cookieValueAsParam }) {
    const { obfuscatePath: doObfuscatePath } = location;
    const { origin } = window.location;
    const { restPathObfuscateOffset } = options;
    const apiUrl = new URL(options.restRoot, origin);
    const query = Object.fromEntries(apiUrl.searchParams.entries());
    const permalinkPath = query.rest_route || apiUrl.pathname; // Determine path from permalink settings
    // Find parameters from passed location
    const { searchParams: pathSearchParams, pathname: fixedPathName } = new URL(location.path, origin);
    const getParams = Object.fromEntries(pathSearchParams.entries());
    // Find dynamic parameters from URL bindings (like /user/:id)
    const foundParams = [];
    const path = fixedPathName.replace(/:([A-Za-z0-9-_]+)/g, (match, group)=>{
        foundParams.push(group);
        return params[group];
    });
    // Find undeclared body params (which are not bind above) and add it to GET query
    for (const checkParam of Object.keys(params)){
        if (foundParams.indexOf(checkParam) === -1) {
            getParams[checkParam] = params[checkParam]; // We do not need `encodeURIComponent` as it is supported by `URLSearchParams` already
        }
    }
    // Calculate invalidator for cookie values
    if (cookieValueAsParam) {
        getParams._httpCookieInvalidate = `${simpleHash(JSON.stringify(cookieValueAsParam.map(Cookie.get)))}`;
    }
    // Force protocol from parent location
    apiUrl.protocol = window.location.protocol;
    // Set path depending on permalink settings
    const usePermalinkPath = trailingslashit(permalinkPath); // => `/wp-json`
    let useAfterPermalinkPath = untrailingslashit(location.namespace || options.restNamespace) + path; // => `/real-cookie-banner/v1/consent`
    if (restPathObfuscateOffset && doObfuscatePath) {
        useAfterPermalinkPath = obfuscatePath(restPathObfuscateOffset, useAfterPermalinkPath, doObfuscatePath);
    }
    const usePath = `${usePermalinkPath}${useAfterPermalinkPath}`;
    if (query.rest_route) {
        query.rest_route = usePath;
    } else {
        apiUrl.pathname = usePath; // Set path
    }
    // Append WordPress REST nonce
    if (nonce && options.restNonce) {
        query._wpnonce = options.restNonce;
    }
    // Determine if non-GET verbs should always use `POST`
    applyQueryString(apiUrl, query);
    if ([
        "wp-json/",
        "rest_route="
    ].filter((s)=>apiUrl.toString().indexOf(s) > -1).length > 0 && location.method && location.method !== ERouteHttpVerb.GET) {
        applyQueryString(apiUrl, [
            {
                _method: location.method
            }
        ], true);
    }
    // Build final search
    applyQueryString(apiUrl, [
        options.restQuery,
        getParams
    ], true);
    return apiUrl.toString();
}
export { commonUrlBuilder, applyQueryString };
